import { Component, OnInit } from '@angular/core';
import { SessionService } from "src/app/services/session.service";
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  userID: any;
  username: any;
  applicationname: any;

  constructor() { }

  ngOnInit() {
    this.userID = localStorage.getItem("id");
    this.username = localStorage.getItem("name");
    this.applicationname = localStorage.getItem("application_name");
    // this.userID = localStorage.getItem("id");
    // this.userID = localStorage.getItem("id");
    // this.userID = localStorage.getItem("id");

    // $(".mobile-menu-btn").click(function(){
    //   $(".sidebard-bg").toggleClass("display-none");
    // });


  }

  Mobile_sidebar_menu_btn(){
    $(".mobile-menu-asidebar").fadeToggle(500);
  }
  

}
